import {ff} from 'mc/lib';
import {Form, FormActions, FormBody} from 'mc/lib/form';
import {localUTCToDate, removeTime} from 'mc/lib/utils/commons';
import PropTypes from 'prop-types';
import React from 'react';
import {Col, Row} from 'reactstrap';
import {reduxForm} from 'redux-form';

/**
 * Formulář pro vratky.
 */
class VratkaForm extends React.Component {

    static validate(values, props) {
        const {castka, datumSplatnosti, cisloUctu} = values;
        const {maxVratka, cisloUctuVisible} = props;
        const errors = {};

        if (castka == null || castka === '') {
            errors.castka = 'Částka k vrácení musí být vyplněna.';
        } else if (castka <= 0) {
            errors.castka = 'Částka k vrácení musí být kladná.';
        } else if (maxVratka != null && castka > maxVratka) {
            errors.castka = 'Částka k vrácení nesmí překročit částku platby.';
        }

        if (!datumSplatnosti) {
            errors.datumSplatnosti = 'Datum splatnosti musí být vyplněno.';
        } else if (localUTCToDate(datumSplatnosti) < removeTime(new Date())) {
            errors.datumSplatnosti = 'Datum splatnosti nesmí být z minulosti.';
        }

        if (cisloUctuVisible && !cisloUctu) {
            errors.cisloUctu = 'Bankovní účet není vyplněn.';
        }

        return errors;
    }

    static formName = 'vratkaForm';

    static propTypes = {
        cisloUctuVisible: PropTypes.bool,
        cisloUctuDisabled: PropTypes.bool,
        maxVratka: PropTypes.number,
    };

    static defaultProps = {
        cisloUctuVisible: false,
        cisloUctuDisabled: false,
    };

    render() {
        const {onClose, submitting, handleSubmit, cisloUctuVisible, cisloUctuDisabled} = this.props;
        return (
            <Form onSubmit={handleSubmit} horizontal>
                <FormBody>
                    <Row>
                        <Col className="vratka-input-50">
                            <ff.Currency label="Částka k vrácení" name="castka" required  disabled={submitting}/>
                        </Col>
                    </Row>
                    {cisloUctuVisible && (
                        <ff.String label="Bankovní účet" name="cisloUctu" required disabled={cisloUctuDisabled}/>
                    )}
                    <Row>
                      <Col className="vratka-input-40">
                        <ff.SimpleDate label="Datum splatnosti" name="datumSplatnosti" required disabled={submitting}/>
                      </Col>
                    </Row>
                    <ff.Textarea rows="4" label="Poznámka" name="poznamka" disabled={submitting}/>
                </FormBody>
                <FormActions onClose={onClose} submitButton="Vrátit" cancelButton="Zrušit" disabled={submitting}/>
            </Form>
        );
    }
}

const formConfig = {
    form: VratkaForm.formName,
    validate: VratkaForm.validate,
};

export default reduxForm(formConfig)(VratkaForm);
